import {endpoint} from "./endpoint";

export const login = endpoint({
  url: "/ui/login",
  method: "post",
  params: undefined,
  payload: undefined,
  validate: undefined,
  shape: undefined,
});
